//codex-- Keep the toolbar redesign scoped to pages in this folder.
import PageToolbar, { ToolbarField } from './PageToolbar';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { ArrowPathIcon } from '@heroicons/react/20/solid';
import { toast } from 'react-toastify';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import HeadingCp from '../components/HeadingCp';
import ServiceCallDetailsModal from '../components/ServiceCallDetailsModal';
import ServiceCallFormModal from '../components/ServiceCallFormModal';
import DayViewTimelineService from '../components/DayViewTimelineService';
import AdditionalTech from '../mobile/AdditionalTech';
import UnifiedDayTimeline from '../components/UnifiedDayTimeline';
import InspectionFormModal from '../components/InspectionFormModal';
import InspectionDetailsModal from '../components/InspectionDetailsModal';
import WipFormModal from '../components/WipFormModal';
import WipSchedulerDetailsModal from '../components/WipSchedulerDetailsModal';
import FullCalendarHeader from '../components/FullCalendarHeader';
import SearchBarCP from '../components/SearchBarCP';
import { set } from 'date-fns';
import OperationSchedulerDetailModal from '../components/OperationSchedulerDetailModal';
import LegendCP from '../components/LegendCP';
import OperationFormModal from '../components/OperationFormModal';
import { SquaresPlusIcon } from '@heroicons/react/24/outline';
import LoadingSpinner from '../components/LoadingSpinner';
//codex-- Load the authenticated employee's default while retaining the current scheduler filtering.
import { useUserData } from '../context/UserData';
import useSchedulerDepartment from '../hooks/useSchedulerDepartment';
import { SCHEDULER_DEPARTMENTS } from '../utils/fullSchedulerSettings';


const FullSchedulerViewer = () => {
  const [editDateMode, setEditDateMode] = useState(false);
  const pollingRef = useRef(null);
  const [serviceCalls, setServiceCalls] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState([]);
  const [viewMode, setViewMode] = useState('day'); // 'week' or 'day'
  const location = useLocation();

  // Confirm Delete Modal states
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  //wip delete confirmation
  const [showWipConfirmModal, setShowWipConfirmModal] = useState(false);
  const [wipDeleteId, setWipDeleteId] = useState(null);

  // const [selectedDay, setSelectedDay] = useState(null); // Used in day view
  const [selectedDay, setSelectedDay] = useState(new Date());
  const apiUrl = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(false);
  const timeSlots = Array.from({ length: 24 }, (_, hour) => hour);
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state for adding/editing service call
  const [formData, setFormData] = useState({
    TROUBLE: '',
    CUSTOMER: '',
    ADDRESS: '',
    CALLED_BY: '',
    PHONE: '',
    TECH: '',
    NOTES: '',
    TIME: '',
    end_time: '',
    SCHEDULE_DATE: '',
    customer_id: '',
    additional_tech: '',
    additional_tech_id: '',
    tentative: false,
  });
  const [isEditing, setIsEditing] = useState(false); // Flag to check if editing
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false); // Modal state for viewing service call details
  
  const [isServiceModalOpen, setIsServiceModalOpen] = useState(false);
  const [selectedServiceCall, setSelectedServiceCall] = useState(null);

  const [selectedCompany, setSelectedCompany] = useState(null);
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [selectedTechs, setSelectedTechs] = useState([]); // New state for multiple techs
  //codex-- A manual view selection wins over a delayed preference read and is never saved here.
  const employeeId = useUserData()?.users?.id;
  const [selectedDept, setSelectedDept] = useSchedulerDepartment(apiUrl, employeeId);

  /* a memo-ised list of departments for the dropdown */
  const departmentOptions = React.useMemo(() => {
    const depts = new Set(employees.map(e => e.department).filter(Boolean));
    return ['All', ...depts];
  }, [employees]);  

  //codex-- Share the exact persisted values without changing this client's Field classification rule.
  const allowedDepartments = SCHEDULER_DEPARTMENTS;

  // const [eventSearchTerm, setEventSearchTerm] = useState('');
  // const [filteredEvents, setFilteredEvents] = useState([]);
  
  const [pendingSlot, setPendingSlot] = useState(null); // { date, techId, hour, minute }
  const [scheduleTypeModalOpen, setScheduleTypeModalOpen] = useState(false);
  const [disabled, setDisabled] = useState(false); //inspection form disabled state
  const [allEvents, setAllEvents] = useState([]); // unified array with {type: 'service'|'wip'|'inspection'}
 
  // For Inspection details modal
  const [selectedInspection, setSelectedInspection] = useState(null);
  const [isInspectionModalOpen, setIsInspectionModalOpen] = useState(false);
  const [isInspectionDetailModalOpen, setIsInspectionDetailModalOpen] = useState(false);
  const [isInsEditing, setIsInsEditing] = useState(false); // Flag to check if editing

  // For WIP details modal
  const [selectedWipJob, setSelectedWipJob] = useState(null);
  const [isWipModalOpen, setIsWipModalOpen] = useState(false);
  const [isWipDetailModalOpen, setIsWipDetailModalOpen] = useState(false);
  const [isWipEditing, setIsWipEditing] = useState(false); // Flag to check if editing

  // For Operation Schedule details modal
  const [isOperationDetailModalOpen, setIsOperationDetailModalOpen] = useState(false);
  const [selectedOperation, setSelectedOperation] = useState(null);
  const [isEditingOp, setIsEditingOp] = useState(false); // Flag to check if editing operation schedule

  const [isTechFilterModalOpen, setIsTechFilterModalOpen] = useState(false); //for filtering techs in the unified day view
  const [pendingSelectedTechs, setPendingSelectedTechs] = useState([]);//for filtering techs in the unified day view

  const [isOperationModalOpen, setIsOperationModalOpen] = useState(false);
  const [opFormData, setOpFormData] = useState({
    id: '',
    description: '',
    status: 'Scheduled',
    date: '',
    time_log: '',
    user: '',
    schedule_from: '',
    schedule_to: '',
    start_time: '',
    end_time: '',
    tech_id: '',
    tech_name: '',
    tech_notes: '',
    user_comment: '',
    multi_tech_ids: [],
  });



 const fetchAllDayEvents = useCallback(async (dateObj) => {
    setLoading(true);
    try {
      const dayISO = [
        dateObj.getFullYear(),
        (dateObj.getMonth() + 1).toString().padStart(2, '0'),
        dateObj.getDate().toString().padStart(2, '0')
      ].join('-');
      // 1. Fetch all events for the day
      const [inspections, serviceCalls, wipJobs, vacations, opSchedule] = await Promise.all([
        axios.get(`${apiUrl}/contracts_crud.php`, { params: { getInspections: 1, month: 'all', startDate: dayISO, endDate: dayISO } }),
        axios.get(`${apiUrl}/service_crud.php`, { params: { getListByDate: 1, date: dayISO } }),
        axios.get(`${apiUrl}/wip_crud.php`, { params: { getWipScheduleList: 1, month:'scheduler', startDate: dayISO, endDate: dayISO } }),
        axios.get(`${apiUrl}/tech_crud.php`, { params: { getVacations: 1, date: dayISO} }),
        axios.get(`${apiUrl}/operation_crud.php`, { params: { getOpScheduleList: 1, month:'all', startDate: dayISO, endDate: dayISO } }),
      ]);

      // console.log('inspections', inspections.data, 'startDate', dayISO, 'endDate', dayISO);
      // console.log('serviceCalls', serviceCalls.data, 'startDate', dayISO, 'endDate', dayISO);
      // console.log('wipJobs', wipJobs.data, 'startDate', dayISO, 'endDate', dayISO);
      // console.log('vacations', vacations.data, 'startDate', dayISO, 'endDate', dayISO);
      // console.log('opSchedule', opSchedule.data, 'startDate', dayISO, 'endDate', dayISO);

      // 2. Normalize (add .type to each event, harmonize keys)
      const normalize = (arr, type) =>
        (Array.isArray(arr) ? arr : []).map(ev => ({
          ...ev,
          type,
          tech_id: ev.tech_id || ev.lead_tech_id || ev.TECH, 
          job_site: ev.job_site || ev.job_site_name || ev.ADDRESS,
          customer: ev.customer_name || ev.CUSTOMER,
          start_time: ev.schedule_time_in || ev.TIME || ev.start_time,
          end_time: ev.schedule_time_out || ev.end_time,
          description: ev.description
          // Add any more normalizations you need
        }));

      //   // Normalize vacation events as well:
      // const normalizeVacation = (arr) =>
      //   (Array.isArray(arr) ? arr : []).map(ev => ({
      //     ...ev,
      //     type: 'OFF',
      //     tech_id: ev.employee_id,
      //     employee_name: ev.employee_name,
      //     date_out: ev.date_out,
      //     date_end: ev.date_end,
      //     vacationLabel: ev.date_request,
      //     start_time: "08:00:00",   // <--- default start
      //     end_time: "16:00:00",     // <--- default end
      //   }));

      // Helper: shift a Y-M-D string by N days
      function shiftDateISO(dateStr, deltaDays) {
        if (!dateStr) return dateStr;
        const [y, m, d] = dateStr.split('-').map(Number);
        if (!y || !m || !d) return dateStr;

        const dt = new Date(y, m - 1, d);
        dt.setDate(dt.getDate() + deltaDays);

        const yy = dt.getFullYear();
        const mm = String(dt.getMonth() + 1).padStart(2, '0');
        const dd = String(dt.getDate()).padStart(2, '0');
        return `${yy}-${mm}-${dd}`;
      }

      const normalizeVacation = (arr) =>
        (Array.isArray(arr) ? arr : []).map(ev => {
          // date_out is the first OFF day
          const dateOut = ev.date_out;

          // date_end is the RETURN date for "Vacation Day" → subtract 1 day
          let dateEnd = ev.date_end;
          if (ev.date_request === 'Vacation Day' && ev.date_end) {
            dateEnd = shiftDateISO(ev.date_end, -1);
          }

          return {
            ...ev,
            type: 'OFF',
            tech_id: ev.employee_id,
            employee_name: ev.employee_name,
            date_out: dateOut,
            date_end: dateEnd,
            vacationLabel: ev.date_request,
            start_time: "08:00:00",   // default start
            end_time: "16:00:00",     // default end
          };
        });


      setAllEvents([
        ...normalize(inspections.data[0], 'inspection'),
        ...normalize(serviceCalls.data, 'service'),
        ...normalize(wipJobs.data[0], 'wip'),
        ...normalize(opSchedule.data[0], 'operations'),
        ...normalizeVacation(vacations.data),
      ]);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        navigate('/login');
      } else if (err.response && err.response.status === 403) {
        toast.error('Access denied.', {
          position: 'top-center',
        });
      } else {
        toast.error('Error loading events for day');
      }
    } finally {
      setLoading(false);
    }
  }, [apiUrl]); 

  useEffect(() => {
    setLoading(true);
    const fetchEmployees = async () => {
      try {
        const response = await axios.get(`${apiUrl}/service_crud.php?employee_list=true`, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        });
        const employeesData = Array.isArray(response.data) ? response.data : [];
        if (employeesData.length === 0) {
          toast.error('No employees found!', { position: 'top-center' });
        }
        setEmployees(employeesData);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          navigate('/login');
        } else if (error.response && error.response.status === 403) {
          toast.error("Oops!! you don't have access to this area. Speak to the CFO.", {
            position: 'top-center',
          });
        }
      } finally {
        setLoading(false);
      }
    };

    fetchEmployees();
  }, [apiUrl, navigate]);

  useEffect(() => {
   if (viewMode === 'day' && selectedDay) {
     fetchAllDayEvents(selectedDay);
   } else {
    const currentWeekStart = getWeekStart();
    setSelectedWeek(getWeekDates(currentWeekStart)); // Set the initial week (current week)
    fetchServiceCalls(apiUrl, navigate);
   }
 }, [viewMode, selectedDay, apiUrl, navigate]);

 //added this useEffect below to handle pulling - every hour if no modals are open 
  useEffect(() => {
    const modalOpen =
      isModalOpen ||
      isInspectionModalOpen ||
      isInspectionDetailModalOpen ||
      isWipDetailModalOpen ||
      isDetailModalOpen;

    if (!modalOpen) {
      pollingRef.current = setInterval(() => {
        fetchAllDayEvents(selectedDay);
      }, 60 * 60 * 1000); // 1 hour
    }

    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    };
  }, [
    selectedDay,
    isModalOpen,
    isInspectionModalOpen,
    isInspectionDetailModalOpen,
    isWipDetailModalOpen,
    isDetailModalOpen,
    fetchAllDayEvents
  ]); // (should be memoized if defined in component)

 useEffect(() => {
  const params = new URLSearchParams(location.search);
  const dateParam = params.get('date');

  if (!dateParam) return;

  const [year, month, day] = dateParam.split('-').map(Number);
  if (!year || !month || !day) return;

  const parsedDate = new Date(year, month - 1, day);

  if (!isNaN(parsedDate.getTime())) {
    setSelectedDay(parsedDate);
    setViewMode('day');
  }
  }, [location.search]); 

  useEffect(() => { //filter techs when dept changes
    setSelectedTechs([]);
  }, [selectedDept]);  

  // useEffect(() => {
  //   if (!eventSearchTerm) {
  //     setFilteredEvents(allEvents);
  //   }
  // }, [allEvents, eventSearchTerm]);  

  const handleApiError = (error) => {
    if (error.response && error.response.status === 401) {
      navigate('/login');
    } else if (error.response && error.response.status === 403) {
      toast.error('Access denied.', {
        position: 'top-center',
      });
    } else {
      toast.error('An error occurred while fetching data.', {
        position: 'top-center',
      });
    }
  };

  function getTechNameById(techId, employeesList) {
    const emp = employeesList.find(e => String(e.id) === String(techId));
    return emp ? `${emp.first_name} ${emp.last_name}` : '';
  } 

  const fetchServiceCalls = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${apiUrl}/service_crud.php?getList=1`, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        });
        const calls = Array.isArray(response.data) ? response.data : [];
        if (calls.length === 0) {
          // toast.error('No service calls found!', { position: 'top-center' });
        } else {
          // Ensure 'end_time' is included in each service call
          setServiceCalls(
            calls.map((call) => ({
              ...call,
              end_time: call.end_time || '', // Default to empty string if not present
            }))
          );
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          toast.error('Session expired. Please login again.', {
            position: 'top-center',
          });
          navigate('/login');
        } else if (error.response && error.response.status === 403) {
          toast.error("Oops!! you don't have access to this area. Speak to the CFO.", {
            position: 'top-center',
          });
        }
      } finally {
        setLoading(false);
      }
  };

  // Function to generate random colors for events
  const getRandomColor = () => {
    const colors = [
      'bg-red-200',
      'bg-blue-200',
      'bg-green-200',
      'bg-yellow-200',
      'bg-purple-200',
      'bg-pink-200',
      'bg-indigo-200',
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  const techColors = {};
  const getTechColor = (techName) => {
    if (!techColors[techName]) {
      techColors[techName] = getRandomColor();
    }
    return techColors[techName];
  };

  const handleReset = () => {
    window.location.reload();
  };

  // Helper function to get the start of the week (Monday)
  const getWeekStart = (date = new Date()) => {
    const dayOfWeek = (date.getDay() + 6) % 7; // Adjust to get Monday as the first day
    const diff = date.getDate() - dayOfWeek;
    return new Date(date.setDate(diff));
  };

  // Get array of dates for the selected week
  const getWeekDates = (startOfWeek) => {
    const dates = [];
    for (let i = 0; i < 7; i++) {
      const currentDay = new Date(startOfWeek);
      currentDay.setDate(startOfWeek.getDate() + i);
      dates.push(new Date(currentDay));
    }
    return dates;
  };

  // Handle moving to the previous week
  const handlePreviousWeek = () => {
    const previousWeekStart = new Date(selectedWeek[0]); // Start of the current week
    previousWeekStart.setDate(previousWeekStart.getDate() - 7); // Move back 7 days
    setSelectedWeek(getWeekDates(previousWeekStart));
  };

  // Handle moving to the next week
  const handleNextWeek = () => {
    const nextWeekStart = new Date(selectedWeek[0]); // Start of the current week
    nextWeekStart.setDate(nextWeekStart.getDate() + 7); // Move forward 7 days
    setSelectedWeek(getWeekDates(nextWeekStart));
  };

  // Handle moving to the previous day
  const handlePreviousDay = () => {
    const previousDay = new Date(selectedDay);
    previousDay.setDate(previousDay.getDate() - 1);
    setSelectedDay(previousDay);
    fetchServiceCallsForDay(previousDay); 
  };

  // Handle moving to the next day
  const handleNextDay = () => {
    const nextDay = new Date(selectedDay);
    nextDay.setDate(nextDay.getDate() + 1);
    setSelectedDay(nextDay);
    fetchServiceCallsForDay(nextDay); 
  };

  // Handle view mode change
  const handleViewChange = (e) => {
    const view = e.target.value;
    setViewMode(view);
    if (view === 'day') {
      setSelectedDay(prev => prev || new Date()); // only set if not already set
    }
  };

  // Handle opening the modal for adding/editing service call
  const openModal = (isEdit = false) => {
    setIsEditing(isEdit);
    setIsModalOpen(true);
  };

  // Handle closing the modal for adding/editing service call
  const closeModal = () => {
    setIsModalOpen(false);
    setIsEditing(false);
    setFormData({
      TROUBLE: '',
      CUSTOMER: '',
      ADDRESS: '',
      CALLED_BY: '',
      PHONE: '',
      TECH: '',
      NOTES: '',
      TIME: '',
      end_time: '',
      SCHEDULE_DATE: '',
      customer_id: '',
    });
    setSelectedCompany(null);
  };

  const handleCompanySelect = (newJobSite) => {
    if (newJobSite && newJobSite.full_address) {
      setSelectedCompany(newJobSite);
      setFormData((prev) => ({
        ...prev,
        CUSTOMER: newJobSite.customer_name,
        ADDRESS: newJobSite.full_address,
        customer_id: newJobSite.customer_id,
        NOTES: newJobSite.notes || '',
      }));
    } else {
      // console.error('Invalid company selected:', newJobSite);
    }
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === 'tech_id'
        ? { multi_tech_ids: [] }
        : {}),
    }));
  };

  // Handle form submission
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    // Basic validation
    if (!formData.CUSTOMER || !formData.ADDRESS || !formData.TROUBLE) {
      toast.error('Please fill in the required fields.');
      return;
    }
    if (String(formData.tech_id) === String(formData.additional_tech) && formData.additional_tech) {
      toast.error("Lead Tech and Additional Tech cannot be the same person.", {
        position: 'top-center',});
      return;
    }
    if (formData.TIME && formData.end_time) {
      const startTime = new Date(`1970-01-01T${formData.TIME}:00`);
      const endTime = new Date(`1970-01-01T${formData.end_time}:00`);
      if (endTime <= startTime) {
        toast.error("End time must be after start time.", {
          position: 'top-center',});
        return;
      }
    }
    try {
      if (isEditing) {
        const NewBodyData = {
          data: formData,
          id: formData.id,
          status: 'addServiceCall',
        };
        const response = await axios.post(`${apiUrl}/service_crud.php`, NewBodyData, {
          headers: { 'Content-Type': 'application/json' },
        });
        if (response.data[0] === 'success') {
          // ⬇️ The important part:
          closeModal();
          toast.success('Service call updated successfully!');
          if (viewMode === 'day' && selectedDay) {
            fetchAllDayEvents(selectedDay); // force refresh unified view
          } else {
            fetchServiceCalls();
          }
        } else {
          toast.error(response.data.error || 'Failed to update service call.');
        }
      } else {
        const NewBodyData = {
          data: formData,
          id: 'new',
          status: 'addServiceCall',
        };
        // Add new service call
        const response = await axios.post(`${apiUrl}/service_crud.php`, NewBodyData, {
          headers: { 'Content-Type': 'application/json' },
        });
        if (response.data[0] === 'success') {
          toast.success('Service call added successfully!');
          closeModal();
          reFetchCurrentView();
        } else {
          toast.error(response.data.error || 'Failed to add service call.');
        }
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! you don't have access to this area. Speak to the CFO.", {
          position: 'top-center',
        });
      }
    }
  };

  // Handle clicking on a time slot
  const handleTimeSlotClick = (date, hour) => {
    // Build the datetime object
    const selectedDateTime = new Date(date);
    selectedDateTime.setHours(hour);
    selectedDateTime.setMinutes(0);
    selectedDateTime.setSeconds(0);
    selectedDateTime.setMilliseconds(0);

    // Calculate default end time (e.g., 1 hour later)
    const defaultEndTime = new Date(selectedDateTime.getTime() + 1 * 60 * 60 * 1000);

    // Open the modal
    openModal(false); // Not editing

    // Set the form data
    setFormData((prevData) => ({
      ...prevData,
      SCHEDULE_DATE: date.toLocaleDateString('en-CA'), // format as YYYY-MM-DD
      TIME: selectedDateTime.toTimeString().split(' ')[0].slice(0, 5), // format as HH:MM
      end_time: defaultEndTime.toTimeString().split(' ')[0].slice(0, 5),
    }));
  };

  // Handle clicking on a service call event
  const handleEventClick = (serviceCall) => {
    setSelectedServiceCall(serviceCall);
    setIsDetailModalOpen(true);
  };

  // Close the detail modal
  const closeDetailModal = () => {
    setIsDetailModalOpen(false);
    setSelectedServiceCall(null);
  };

  // Handle editing a service call
  const handleEditServiceCall = () => {
    // Populate form data with selected service call
    setFormData(selectedServiceCall);
    if(selectedServiceCall.add_tech && selectedServiceCall.add_tech.length > 0) {
      setFormData((prevData) => ({
        ...prevData,
        additional_tech: selectedServiceCall.add_tech[0].tech_id || '',
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        tentative: selectedServiceCall.STATUS === 'tentative' ? true : false
      }));
    }
    closeDetailModal(); // Close the detail modal
    openModal(true); // Open the modal in edit mode
  };

  const handleDeptChange = async (e) => {
    const dept = e.target.value;
    setSelectedDept(dept);

    /* build the list of tech full-names that belong to that dept */
    const techNames =
      dept === 'All'
        ? []                                             // = show all
        : employees
            .filter(emp => emp.department === dept)
            .map(emp => `${emp.first_name} ${emp.last_name}`);

    /* trigger the same filtering you already have */
    const fakeEvent = { target: { options: techNames.map(t => ({ selected:true, value:t })) } };
    handleFilterTech(fakeEvent);
  };

  const handleFilterTech = async (event) => {
    const options = event.target.options;
    const selectedValues = [];
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selectedValues.push(options[i].value);
      }
    }
    setSelectedTechs(selectedValues);

    setLoading(true);
    try {
      let calls = [];
      if (selectedValues.length === 0) {
        // No techs selected, fetch all service calls
        const response = await axios.get(`${apiUrl}/service_crud.php?getList=1`, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        });
        calls = Array.isArray(response.data) ? response.data : [];
      } else {
        const FilterBodyData = {
          techNames: selectedValues,
          status: 'filter_tech',
        };
        // Filter service calls by technicians
        const response = await axios.post(`${apiUrl}/service_crud.php`, FilterBodyData, {
          headers: { 'Content-Type': 'application/json' },
        });
        calls = Array.isArray(response.data) ? response.data : [];
      }

      if (calls.length === 0) {
        // toast.error('No service calls found!', { position: 'top-center' });
      } else {
        setServiceCalls(
          calls.map((call) => ({
            ...call,
            end_time: call.end_time || '',
          }))
        );
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! you don't have access to this area. Speak to the CFO.", {
          position: 'top-center',
        });
      }
    } finally {
      setLoading(false);
    }
  };

  // fetch every call scheduled on one specific calendar date (YYYY-MM-DD)
  const fetchServiceCallsForDay = async (dateObj) => {
    setLoading(true);
    try {
      const iso = [
        dateObj.getFullYear(),
        (dateObj.getMonth() + 1).toString().padStart(2, '0'),
        dateObj.getDate().toString().padStart(2, '0')
      ].join('-');       // "2025-05-03"
      const { data } = await axios.get(`${apiUrl}/service_crud.php`, {
        params : { getListByDate: 1, date: iso }                // <-- backend needs this
      });
      const calls = Array.isArray(data) ? data : [];
      setServiceCalls(calls.map(c => ({ ...c, end_time: c.end_time || '' })));
    } catch (err) {
      toast.error('Could not load calls for that day');
    } finally {
      setLoading(false);
    }
  };

  const reFetchCurrentView = () => {
    if (viewMode === 'day' && selectedDay) {
      fetchAllDayEvents(selectedDay);
    } else {
      fetchServiceCalls();
    }
  };

  const handleUnifiedEventClick = (eventObj) => {
    if (eventObj.type === 'service') {
      setSelectedServiceCall(eventObj);
      setIsDetailModalOpen(true);
    } 
    else if (eventObj.type === 'inspection') {
      setSelectedInspection(eventObj);
      setIsInspectionDetailModalOpen(true);
    } 
    else if (eventObj.type === 'wip') {
      setSelectedWipJob(eventObj);
      setIsWipDetailModalOpen(true);
    }
    else if (eventObj.type === 'operations') {
      setSelectedOperation(eventObj);
      setIsOperationDetailModalOpen(true);
    }
    // (You'll need separate modal state for each type if showing them at once)
  };

  const handleUnifiedEmptySlot = (dayDate, techId, hour, minute) => {
    setPendingSlot({ dayDate, techId, hour, minute });
    setScheduleTypeModalOpen(true);
  };

  const handleScheduleTypeSelect = (type) => {
    if (!pendingSlot) return;
    let { dayDate, techId, hour, minute } = pendingSlot;
    
    const techName = getTechNameById(techId, filteredEmployees);
     
    // Defensive: Make sure dayDate is a valid Date object
    let selectedDate = dayDate instanceof Date && !isNaN(dayDate)
      ? new Date(dayDate)
      : new Date();

    // If still not valid, fallback to now
    if (isNaN(selectedDate)) selectedDate = new Date();

    selectedDate.setHours(hour ?? 0);
    selectedDate.setMinutes(minute ?? 0, 0, 0);

    // Defensive: always get the date string safely
    const dateStr = !isNaN(selectedDate)
      ? selectedDate.toLocaleDateString('en-CA')
      : new Date().toLocaleDateString('en-CA');

    // Format times safely (always two digits)
    const pad = v => String(v).padStart(2, '0');
    const timeStr = `${pad(hour ?? 0)}:${pad(minute ?? 0)}`;
    const endHour = (hour ?? 0) + 1;
    const endTimeStr = `${pad(endHour)}:${pad(minute ?? 0)}`;
    const timeStrWithSec = `${pad(hour ?? 0)}:${pad(minute ?? 0)}:00`;
    const endTimeStrWithSec = `${pad(endHour)}:${pad(minute ?? 0)}:00`;

    setScheduleTypeModalOpen(false);

    if (type === 'service') {
      setFormData(prev => ({
        ...prev,
        SCHEDULE_DATE: dateStr,
        TIME: timeStr,
        end_time: endTimeStr,
        TECH: techName,
      }));
      setIsModalOpen(true);
      setIsEditing(false);
    } else if (type === 'inspection') {
      setFormData(prev => ({
        ...prev,
        scheduled_due_date: dateStr,
        schedule_time_in: timeStrWithSec,
        schedule_time_out: endTimeStrWithSec,
        lead_tech_id: techId,
      }));
      setIsInspectionModalOpen(true);
      setIsInsEditing(false);
    } else if (type === 'wip') {
      setFormData(prev => ({
        ...prev,
        schedule_from: dateStr,
        start_time: timeStrWithSec,
        end_time: endTimeStrWithSec,
        tech_id: techId,
    }));
      setIsWipModalOpen(true);
      setIsWipEditing(false);
    } else if (type === 'operation') {
      setOpFormData(prev => ({
        ...prev,
        schedule_from: dateStr,
        schedule_to: dateStr,
        date: dateStr,
        start_time: timeStrWithSec,
        end_time: endTimeStrWithSec,
        tech_id: techId,
        time_log: new Date().toTimeString().slice(0,8),
    }));
      setIsOperationModalOpen(true);
      setIsEditingOp(false);
    }
    setPendingSlot(null);
  };

const filteredEmployees = !selectedDept || selectedDept === "All Depts"
  ? employees
  : selectedDept === "Field"
    ? employees.filter(e => String(e.o_f_type).toLowerCase() === "field")
    : employees.filter(e => e.department === selectedDept);

const visibleEmployees =
  selectedTechs.length > 0
    ? filteredEmployees.filter(emp =>
        selectedTechs.includes(`${emp.first_name} ${emp.last_name}`)
      )
    : filteredEmployees;

const visibleTechOptions = filteredEmployees.map(emp => ({
  id: String(emp.id),
  name: `${emp.first_name} ${emp.last_name}`,
}));
  

const openTechFilterModal = () => {
  setPendingSelectedTechs(selectedTechs);
  setIsTechFilterModalOpen(true);
};

const togglePendingTech = (techName) => {
  setPendingSelectedTechs(prev =>
    prev.includes(techName)
      ? prev.filter(name => name !== techName)
      : [...prev, techName]
  );
};

const applyTechFilter = () => {
  setSelectedTechs(pendingSelectedTechs);
  setIsTechFilterModalOpen(false);
};

const clearTechFilter = () => {
  setPendingSelectedTechs([]);
  setSelectedTechs([]);
  setIsTechFilterModalOpen(false);
};      


   {/* ---- inspection section code ---- */}      
  const handleEditInspection = () => {
    const editableInspection = {
      ...selectedInspection,
      id: selectedInspection.inspection_id, // rename for the form
      tentative: selectedInspection.status === 'tentative' ? true : false
    };
    setFormData(editableInspection);
    setIsInspectionModalOpen(true);
    setIsInspectionDetailModalOpen(false);
    setIsInsEditing(true);
  };

  const closeInspectionDetailModal = () => {
    setIsInspectionDetailModalOpen(false);
    setSelectedInspection(null);
    setIsInsEditing(false);
  }
  // Handle closing the modal for adding/editing service call
  const closeInspectionModal = () => {
    setIsInspectionModalOpen(false);
    setIsInsEditing(false);
    setFormData({ maintenance_id: '',
                  job_site_name: '',
                  lead_tech_id: '',
                  scheduled_due_date: '',
                  schedule_date_to: '',
                  actual_inspection_date: '',
                  status: ''
                  });           
    setSelectedInspection(null);
    setSelectedCompany(null);
  };

  const handleSubmitInspection = async (e) => {
    e.preventDefault();

    const from = formData.scheduled_due_date;   // "YYYY-MM-DD"
    const to   = formData.schedule_date_to;     // "YYYY-MM-DD"
    const next = formData.next_due_date;        // "YYYY-MM-DD"

    // Only validate if values exist
    if (from && to) {
      if (from > to) {
        toast.error('Scheduled "from" date cannot be later than "to" date.', { position: 'top-center' });
        setLoading(false);
        return;
      }
    }    

    // Prevent duplicate tech selection
    if (
      formData.lead_tech_id &&
      formData.additional_tech_d &&
      String(formData.lead_tech_id) === String(formData.additional_tech_id)
    ) {
      toast.error("You cannot use the same technician as Lead Tech and Additional Tech.", {
        position: "top-center",
      });
      return;
    }

    if (formData.schedule_time_out < formData.schedule_time_in) {
      toast.error('Schedule time out must be later than schedule time in.', {
        position: 'top-center',
      });
      return;
    }
    try {
      const response = await axios.post(`${apiUrl}/contracts_crud.php`, {
        data: formData,
        status: 'recordInspection',
      });
      if (response.data.success) {
        toast.success('Inspection saved successfully!');
        setFormData({
          maintenance_id: '',
          job_site_name: '',
          next_due_date: '',
          scheduled_due_date: '',
          schedule_date_to: '',
          actual_inspection_date: '',
          status: '',
          lead_tech_id: '',
          additional_tech_id: '',
          schedule_time_in: '',
          schedule_time_out: '',
          inspection_notes: '',
        });
        closeInspectionModal();
        reFetchCurrentView();
      } else {
        toast.error(response.data.error || 'Failed to save inspection.');
      }
    } catch (error) {
        if (error.response && error.response.status === 401) {
        navigate('/login');
        } else if (error.response && error.response.status === 403) {
          toast.error("Oops!! you don't have access to this area. Speak to the CFO.", {
            position: 'top-center',
          });
        }
    }
  };

  const openInspModal = (isInsEditing = false) => {
      setIsInsEditing(isInsEditing);
      setIsInspectionModalOpen(true);
  };

  const handleDeleteRequest = (idFromChild) => {
    setIsInspectionModalOpen(false); // close the form, like your working page
    // setIsInspectionDetailModalOpen(false); // close the detail modal
    if (!idFromChild) {
      toast.error('No inspection ID to delete');
      return;
    }
    setDeleteId(idFromChild);
    setShowConfirmModal(true);
  };

  const confirmDelete = async () => {
    setShowConfirmModal(false);
    try {
      const response = await axios.post(`${apiUrl}/contracts_crud.php`, {
        data: { id: deleteId },
        status: 'deleteInspection',
      });
      if (response.data.success) {
        toast.success('Inspection successfully deleted!');
        setIsInspectionModalOpen(false); // close inspection modal
        setSelectedInspection(null);
        reFetchCurrentView();
      } else {
        toast.error(response.data.error || 'Failed to delete inspection.');
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const cancelDelete = () => {
    setShowConfirmModal(false);
  };   
  {/* ---- inspection section code ---- */}     
  
  {/* ---- WIP section code ---- */}
  const handleEditWip = () => {
    const editableWip = {
      ...selectedWipJob,
      id: selectedWipJob.schedule_id, // rename for the form
      tentative: selectedWipJob.status === 'tentative' ? true : false
    };
    setFormData(editableWip);
    setIsWipModalOpen(true);
    setIsWipDetailModalOpen(false);
    setIsWipEditing(true);
  };

  const closeWipDetailModal = () => {
    setIsWipDetailModalOpen(false);
    setSelectedWipJob(null);
    setIsWipEditing(false);
  }

  const closeWipModal = () => {
    setIsWipModalOpen(false);
    setIsEditing(false);
    setFormData({
      schedule_id: '',
      job_number: '',
      tech_id: '',
      schedule_from: '',
      schedule_to: '',
      date: '',
      status: '',
      additional_tech_id: '',
    });      
    setSelectedWipJob(null);
    setSelectedCompany(null);
  };      

  const handleWipFormSubmit = async (e) => {
    e.preventDefault();

    const from = formData.schedule_from;   // "YYYY-MM-DD"
    const to   = formData.schedule_to;     // "YYYY-MM-DD"
    const next = formData.next_due_date;        // "YYYY-MM-DD"

    // Only validate if values exist
    if (from && to) {
      if (from > to) {
        toast.error('Scheduled "from" date cannot be later than "to" date.', { position: 'top-center' });
        setLoading(false);
        return;
      }
    }

    // Validate time
    if (formData.end_time < formData.start_time) {
      toast.error('Schedule time out must be later than schedule time in.', {
        position: 'top-center',
      });
      return;
    }

    // Prevent same tech as lead and additional
    if (formData.tech_id && formData.additional_tech_id &&
        String(formData.tech_id) === String(formData.additional_tech_id)) {
      toast.error('You cannot use the same technician as lead and additional.', {
        position: 'top-center',
      });
      return;
    }

    try {
      const response = await axios.post(`${apiUrl}/wip_crud.php`, {
        data: formData,
        status: 'recordJob',
      });
      if (response.data.success) {
        toast.success('Schedule saved successfully!');
        setFormData({
          id: '',
          job_number: '',
          schedule_from: '',
          schedule_to: '',
          date: '',
          status: '',
          tech_id: '',
          start_time: '',
          end_time: '',   // fixed typo from end_tme
          user_comment: '',
          billable: '',
          invoiced: '',
          additional_tech_id: ''
        });
        closeWipModal();
        reFetchCurrentView();
      } else {
        toast.error(response.data.error || 'Failed to save schedule.');
      }
    } catch (error) {
      handleApiError(error);
    }
  };
  {/* ---- WIP section code ---- */}

  {/* ---- operation section code ---- */}
  const handleEditOperation = () => {
  if (!selectedOperation) return;
  const editableOperation = {
    ...selectedOperation,
    id: selectedOperation.schedule_id, // rename for the form
    // tentative: selectedOperation.status === 'tentative' ? true : false
  };
  setOpFormData(editableOperation);
  // setOpFormData({
  //   id: op.id,
  //   description: op.notes || op.description || '',
  //   status: op.status || 'Scheduled',
  //   date: op.meta?.raw_date || op._date || '',
  //   time_log: op.meta?.time_log || '',
  //   user: op.user || '',
  //   schedule_from: op.meta?.schedule_from || op._date || '',
  //   schedule_to: op.meta?.schedule_to || op._date || '',
  //   start_time: op.start_time || '',
  //   end_time: op.end_time || '',
  //   tech_id: op.tech_id || '',
  //   tech_name: op.meta?.tech_name || '',
  //   tech_notes: op.meta?.tech_notes || '',
  //   user_comment: op.meta?.coordinator_comment || '',
  // });

  setIsEditingOp(true);
  setIsOperationDetailModalOpen(false); // close detail modal
  setIsOperationModalOpen(true);       // open form modal
  };

  const handleOperationFormSubmit = async (e) => {
    e.preventDefault();

    const data = opFormData;
    const from = data.schedule_from;   // "YYYY-MM-DD"
    const to   = data.schedule_to;     // "YYYY-MM-DD"

    // Only validate if values exist
    if (from && to) {
      if (from > to) {
        toast.error('Scheduled "from" date cannot be later than "to" date.', { position: 'top-center' });
        setLoading(false);
        return;
      }
    }       
    // Basic validation
    if (!data.status || !data.date) {
      toast.error('Status and Date are required.', { position: 'top-center' });
      return;
    }
    if (data.end_time && data.start_time && data.end_time <= data.start_time) {
      toast.error('End time must be after start time.', { position: 'top-center' });
      return;
    }
    if (!data.end_time && !data.start_time) {
      toast.error('Time required', { position: 'top-center' });
      return;
    }
    if (!data.description || data.description.trim() === '') {
      toast.error('Description is required.', { position: 'top-center' });
      return;
    }

    try {
      const res = await axios.post(
        `${apiUrl}/operation_crud.php`,
        {
          status: 'recordOperation',
          data,
        },
        { headers: { 'Content-Type': 'application/json' } }
      );

      const ok =
        (Array.isArray(res.data) && res.data[0] === 'success') ||
        res.data?.success === true;

      if (ok) {
        toast.success(
          isEditingOp ? 'Operation schedule updated!' : 'Operation schedule created!',
          { position: 'top-center' }
        );

        // Reset form
        setOpFormData({
          id: '',
          description: '',
          status: 'Scheduled',
          date: '',
          time_log: '',
          user: '',
          schedule_from: '',
          schedule_to: '',
          start_time: '',
          end_time: '',
          tech_id: '',
          tech_name: '',
          tech_notes: '',
          user_comment: '',
        });
        setIsOperationModalOpen(false);
        setIsEditingOp(false);
        // refresh the unified day view
        reFetchCurrentView();
        
      } else if (ok.overlaps?.length) {
        const names = ok.overlaps.map(item => item.tech_name).join(', ');
        toast.error(`Overlapping schedule found for: ${names}`);
        return;        
      } else {
        toast.error(res.data?.error || 'Failed to save operation schedule.', {
          position: 'top-center',
        });
      }
    } catch (err) {
      if (err.response?.status === 401) navigate('/login');
      else if (err.response?.status === 403)
        toast.error("Oops!! you don't have access to this area. Speak to the CFO.", {
          position: 'top-center',
        });
      else toast.error('Server error saving operation schedule.', { position: 'top-center' });
    }
  };
  {/* ---- operation section code ---- */}

  const handleDayChange = (dateStr) => {
      // Parse string 'YYYY-MM-DD' to local time
      if (!dateStr) return;
      const [year, month, day] = dateStr.split('-').map(Number);
      const localDate = new Date(year, month - 1, day);
      setSelectedDay(localDate);
  };

  const closeOperationDetailModal = () => {
    setIsOperationDetailModalOpen(false);
    setSelectedOperation(null);
  }

  const handleWipDeleteRequest = async (maybeId) => {
    // Prefer explicit id from caller; otherwise derive safely
    const scheduleId =
      maybeId ??
      formData?.schedule_id ??
      formData?.id ??
      selectedWipJob?.schedule_id ??
      selectedWipJob?.id;

    if (!scheduleId) {
      toast.error('No WIP schedule ID to delete.');
      return;
    }

    try {
      const { data } = await axios.post(
        `${apiUrl}/wip_crud.php`,
        {
          status: 'deleteSchedule',
          // Send both keys so backend can accept either
          data: { schedule_id: String(scheduleId), id: String(scheduleId) },
        },
        { headers: { 'Content-Type': 'application/json' } }
      );

      const ok = (Array.isArray(data) && data[0] === 'success') || data?.success;
      if (ok) {
        toast.success('WIP schedule successfully deleted!');
        closeWipModal();         
        reFetchCurrentView();    
      } else {
        const msg =
          (Array.isArray(data) && data[1]) ||
          data?.error ||
          'Failed to delete WIP schedule.';
        toast.error(msg);
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  // const handleSearchChange = (e) => {
  //   setEventSearchTerm(e.target.value);
  // };

  // const handleSearchClick = () => {
  //   if (!eventSearchTerm) {
  //     setFilteredEvents(allEvents);
  //   } else {
  //     const filtered = allEvents.filter(ev => {
  //       const jobSite = (ev.job_site || ev.job_site_address || '').toLowerCase();
  //       const idStr = ev.id ? ev.id.toString() : '';
  //       const searchLower = eventSearchTerm.toLowerCase();

  //       return jobSite.includes(searchLower) || idStr.includes(searchLower);
  //     });
  //     setFilteredEvents(filtered);
  //   }
  // };

  return (
    <div className="overflow-auto w-[80vw] mx-auto mt-8">
      <HeadingCp label={'Full Scheduler View'} />
      <span className='bg-slate-200 p-2 rounded-lg'>🛑 Overlapping Schedules</span>
      <>{/*codex-- Match the updated toolbar: grouped actions, labeled controls, and lighter original colors. */}
        <PageToolbar title="Scheduler tools" actions={<>
          <button type="button" onClick={openTechFilterModal} className="px-4 py-2 border border-gray-300 text-sm font-medium rounded-md shadow-sm bg-white hover:bg-gray-50">Select Techs</button>
          {selectedTechs.length > 0 && <span className="text-sm text-gray-600">
            {selectedTechs.length} tech{selectedTechs.length > 1 ? 's' : ''}selected</span>}
          <NavLink to="/event_search">
            <button type="button" className="px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-slate-600 hover:bg-slate-700">Event Search</button>
          </NavLink>
          <NavLink to={`/service_dashboard`}>
            <button type="button" className="px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-400 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">Service DB</button>
          </NavLink>
          <button type="button" onClick={() => openModal(false)} className="px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-400 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">Service Call +</button>
          <NavLink to={`/maintenance_inspections`}>
            <button type="button" className="px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-400 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">Inspection DB</button>
          </NavLink>
          <button type="button" onClick={() => openInspModal(false)} className="px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-400 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">Inspection +</button>
          <NavLink to={`/wip_scheduler_list`}>
            <button type="button" className="px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-purple-400 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500">WIP DB</button>
          </NavLink>
          <button type="button" onClick={() => setIsWipModalOpen(true)} className="px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-purple-400 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500">WIP +</button>
          <NavLink to={`/operation_schedule`}>
            <button type="button" className="px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-800 bg-[#ADFF2F] hover:bg-[#ADFF2F] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#ADFF2F]">Opt DB</button>
          </NavLink>
          <button type="button" onClick={() => setIsOperationModalOpen(true)} className="px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-800 bg-[#ADFF2F] hover:bg-[#ADFF2F] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#ADFF2F]">OPT +</button>
        </>}>
          <ToolbarField label="Department"><select value={selectedDept} onChange={e => setSelectedDept(e.target.value)} className="mt-1 block w-40 border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
              <option value="">All Depts</option>
              {allowedDepartments.map(dep => <option key={dep} value={dep}>{dep}</option>)}
            </select></ToolbarField>
          <FullCalendarHeader viewMode={viewMode} selectedWeek={selectedWeek} selectedDay={selectedDay} handlePreviousWeek={handlePreviousWeek} handleNextWeek={handleNextWeek} handlePreviousDay={handlePreviousDay} handleNextDay={handleNextDay} onDayLabelClick={() => setEditDateMode(true)} onDayChange={handleDayChange} editDateMode={editDateMode} />
          <ToolbarField label="View"><select id="view-mode" className="rounded-md border border-gray-300 py-2 px-4" value={viewMode} onChange={handleViewChange}>
              {/* <option value="week">Week View</option> */}
              <option value="day">Day View</option>
            </select></ToolbarField>
          <button onClick={handleReset} className="bg-orange-600 hover:bg-orange-700 text-white px-3 py-2 rounded-md">
            <span className="flex items-center gap-1">
              <ArrowPathIcon className="h-5" />Reset</span>
          </button>
        </PageToolbar>
      </>

      <div className='mb-2'>
        <LegendCP color="fill-orange-300" label="Tentative" />
        <LegendCP color="fill-green-400" label="Completed" />
        <LegendCP color="fill-red-600" label="FDNY Inspections" />
        <LegendCP color="fill-green-600" label="Maintenance Inspection" />
        <LegendCP color="fill-purple-600" label="WIP Schedule" />
        <LegendCP color="fill-blue-600" label="Service Schedule" />
      </div>
      {/* <SearchBarCP search={eventSearchTerm} handleChange={handleSearchChange} onClick={handleSearchClick} /> */}

      {/* Calendar Grid */}
      <div className="overflow-auto">
      {/* <div className="overflow-auto w-[80vw] mx-auto">  80 % of viewport, centred */}
        <div className={`grid ${viewMode === 'week' ? 'grid-cols-8' : 'grid-cols-[auto_1fr]'}`}>
          {/* Week Columns */}
          
          {/* Days Columns */}
          {loading ? (
            <LoadingSpinner children={'loading....'}  />
          ) : (
            <>            
            {viewMode === 'day' && (
              // <UnifiedDayTimeline
              //   dayDate={selectedDay}
              //   events={allEvents}
              //   // events={filteredEvents}
              //   // employees={selectedDept ? employees.filter(e => e.department === selectedDept) : employees}
              //   employees={visibleEmployees}
              //   selectedTechs={selectedTechs}
              //   onEmptySlot={(techId, hour, minute) => handleUnifiedEmptySlot(selectedDay, techId, hour, minute)}
              //   onEventClick={handleUnifiedEventClick}
              // />
              <UnifiedDayTimeline
                dayDate={selectedDay}
                events={allEvents}
                employees={visibleEmployees}
                onEmptySlot={(techId, hour, minute) => handleUnifiedEmptySlot(selectedDay, techId, hour, minute)}
                onEventClick={handleUnifiedEventClick}
              />              
            )}
          </>            
          )}

        </div>
      </div>

      {/* Modal for Adding/Editing Service Call */}
      <ServiceCallFormModal
        isOpen={isModalOpen}
        onClose={closeModal}
        isEditing={isEditing}
        formData={formData}
        onInputChange={handleInputChange}
        onSubmit={handleFormSubmit}
        selectedCompany={selectedCompany} // from selection company component
        handleCompanySelect={handleCompanySelect} // from selection company component
        setFormData={setFormData}
      />

      {/* Modal for Viewing Service Call Details */}
      <ServiceCallDetailsModal
        isOpen={isDetailModalOpen}
        onClose={closeDetailModal}
        serviceCall={selectedServiceCall}
        onEdit={handleEditServiceCall}
      />

     {/* Modal for Inspection Details */}
     {/* ---------------- Inspection Form Modal ---------------- */}
        <InspectionFormModal
          isOpen={isInspectionModalOpen}
          onClose={closeInspectionModal}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleSubmitInspection}
          technicians={filteredEmployees}
          handleDelete={handleDeleteRequest} 
          // handleDelete={() => handleDeleteRequest(formData?.id || formData?.inspection_id)}
          isEditing={isInsEditing}
          disabled={disabled}
        />

        {/* ---------------- Inspection Details Modal ---------------- */}
        <InspectionDetailsModal
          isOpen={isInspectionDetailModalOpen}
          onClose={closeInspectionDetailModal}
          inspection={selectedInspection}
          onEdit={handleEditInspection}
        />   

      {/* ---------------- Confirm Deletion Modal ---------------- */}
      {showConfirmModal && (
        <div className="fixed z-50 inset-0 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen text-center">
            {/* Background overlay */}
            <div className="fixed inset-0 transition-opacity" aria-hidden="true">
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
            {/* Modal panel */}
            <div
              className="inline-block bg-white rounded-lg text-left 
              overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div>
                  <h3 className="text-lg leading-6 font-medium text-gray-900">
                    Confirm Deletion
                  </h3>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Are you sure you want to delete this inspection? This action cannot be
                      undone.
                    </p>
                  </div>
                </div>
              </div>
              {/* Modal actions */}
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse">
                <button
                  onClick={confirmDelete}
                  className="w-full inline-flex justify-center rounded-md border border-transparent 
                  shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 
                  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Delete
                </button>
                <button
                  onClick={cancelDelete}
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 
                  shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 
                  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}        
      {/* ---------------- Inspection Form Modal ---------------- */}   

      {/* ---------------- WIP Schedule Modal ---------------- */} 
        <WipFormModal
          isOpen={isWipModalOpen}
          onClose={closeWipModal}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleWipFormSubmit}
          technicians={filteredEmployees}
          // handleDelete={handleWipDeleteRequest} 
          handleDelete={() => {
            const id = formData?.schedule_id || formData?.id || selectedWipJob?.schedule_id || selectedWipJob?.id;
            if (!id) {
              toast.error('No WIP schedule ID to delete.');
              return;
            }
            handleWipDeleteRequest(id);
          }}
          isEditing={isWipEditing}
          disabled={disabled}
        />
   
        <WipSchedulerDetailsModal
          isOpen={isWipDetailModalOpen}
          onClose={closeWipDetailModal}
          inspection={selectedWipJob}
          onEdit={handleEditWip}
        />
      {/* ---------------- WIP Schedule Modal ---------------- */}   
      
      {/* ---------------- Operation Modal ---------------- */}   
          <OperationFormModal
            isOpen={isOperationModalOpen}
            onClose={() => {
              setIsOperationModalOpen(false);
              setIsEditingOp(false);
            }}
            isEditing={isEditingOp}
            formData={opFormData}
            setFormData={setOpFormData}
            technicians={filteredEmployees}   // same list you pass to Wip/Inspection
            onSubmit={handleOperationFormSubmit}
          />

        <OperationSchedulerDetailModal
          isOpen={isOperationDetailModalOpen}
          onClose={closeOperationDetailModal}
          operation={selectedOperation}
          onEdit={handleEditOperation}
        />

      {/* ---------------- Operation Modal ---------------- */}   
      {scheduleTypeModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded p-6 min-w-[300px] shadow-lg flex flex-col gap-4">
            <div className="text-lg font-semibold mb-2">What do you want to schedule?</div>
            <button className="bg-blue-600 text-white rounded px-4 py-2" 
              onClick={() => handleScheduleTypeSelect('service')}>Service Call</button>
            <button className="bg-green-600 text-white rounded px-4 py-2" 
              onClick={() => handleScheduleTypeSelect('inspection')}>Inspection</button>
            <button className="bg-purple-600 text-white rounded px-4 py-2" 
              onClick={() => handleScheduleTypeSelect('wip')}>WIP Schedule</button>
            <button className="bg-[#ADFF2F] text-gray-800 rounded px-4 py-2" 
              onClick={() => handleScheduleTypeSelect('operation')}>Operation Schedule</button>
            <button className="text-gray-700 underline mt-2" onClick={() => setScheduleTypeModalOpen(false)}>Cancel</button>
          </div>
        </div>
      )}

      {isTechFilterModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold">Filter Technicians</h3>
              <button
                type="button"
                onClick={() => setIsTechFilterModalOpen(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>

            <div className="max-h-80 overflow-y-auto border rounded-md p-3 space-y-2">
              {visibleTechOptions.length === 0 ? (
                <div className="text-sm text-gray-500">No techs found.</div>
              ) : (
                visibleTechOptions.map((tech) => (
                  <label key={tech.id} className="flex items-center gap-3 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={pendingSelectedTechs.includes(tech.name)}
                      onChange={() => togglePendingTech(tech.name)}
                    />
                    <span>{tech.name}</span>
                  </label>
                ))
              )}
            </div>

            <div className="flex justify-between mt-4">
              <div className="flex gap-2">
                <button
                  type="button"
                  onClick={() => setPendingSelectedTechs(visibleTechOptions.map(t => t.name))}
                  className="px-3 py-2 rounded-md bg-gray-100 hover:bg-gray-200 text-sm"
                >
                  Select All
                </button>
                <button
                  type="button"
                  onClick={() => setPendingSelectedTechs([])}
                  className="px-3 py-2 rounded-md bg-gray-100 hover:bg-gray-200 text-sm"
                >
                  Clear
                </button>
              </div>

              <div className="flex gap-2">
                <button
                  type="button"
                  onClick={() => setIsTechFilterModalOpen(false)}
                  className="px-4 py-2 rounded-md border border-gray-300 bg-white hover:bg-gray-50 text-sm"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={applyTechFilter}
                  className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 text-sm"
                >
                  Filter
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default FullSchedulerViewer;
